import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/cotizaciones", "documento": "quotation", "acceso": "sesion", "filas": ["086"], "cita": "Areas/Quotation/Controllers/DashboardController.cs"} satisfies RutaProd;
